import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
} from '@angular/core';
import {
  ScholarshipManagementDto,
  StateDto,
  LgaDto,
  ScholarshipTypeDto,
  ScholarshipCategoryDto,
  ScholarshipSessionDto,
  ScholarshipAwardDurationDto,
  CommunityDto,
  CourseOfStudyDto,
  EpimsGenderDto,
  CountryDto,
  BankDto,
  ScholarshipPaymentDto,
  EpimsBankDetailDto,
  CurrencyDto,
} from '@cradua/data';
import { ScholarshipInfoService } from '../../services/scholarshipinfo.service';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { ModalComponent } from 'libs/shared/src/lib/components/modal/modal.component';
import {
  FormGroup,
  FormControl,
  FormArray,
  Validators,
  FormBuilder,
} from '@angular/forms';
import Swal from 'sweetalert2';
import { map } from 'rxjs/operators';

@Component({
  selector: 'mrsoftapps-view-scholarship-management',
  templateUrl: './view-scholarship-management.component.html',
  styleUrls: ['./view-scholarship-management.component.scss'],
})
export class ViewScholarshipManagementComponent implements OnInit {
  @Input() countries: CountryDto[];
  @Input() states: StateDto[];
  @Input() lgas: LgaDto[];
  @Input() scholarshipTypes: ScholarshipTypeDto[];
  @Input() scholarshipCategories: ScholarshipCategoryDto[];
  @Input() scholarshipData: ScholarshipManagementDto;
  @Input() courseOfStudies: CourseOfStudyDto[];
  @Input() scholarshipSessions: ScholarshipSessionDto[];
  @Input() scholarshipAwardDurations: ScholarshipAwardDurationDto[];
  @Input() genders: EpimsGenderDto[];
  @Input() communities: CommunityDto[];
  @Input() scholarshipManagements: ScholarshipManagementDto[];
  @Input() scholarshipPayments: ScholarshipPaymentDto[];
  @Input() banks: BankDto[];
  @Output() paymentEmit = new EventEmitter<string>();
  @Output() changeEmit = new EventEmitter<any>();
  @Output() taskEmit = new EventEmitter<any>();
  @Output() getPaymentEmit = new EventEmitter<any>();
  @Output() getBankDetailEmit = new EventEmitter<any>();
  @Output() dispatchEdit = new EventEmitter<any>();

  @Input() bankDetails: EpimsBankDetailDto[];
  @Input() currencies: CurrencyDto[];
  bankForm: FormGroup;
  control = new FormControl();
  @Input() routeAnimationsElements: any;
  @Output() onBankDetailEmit = new EventEmitter<EpimsBankDetailDto>();
  @Output() deleteBankDetailEvent = new EventEmitter<any>();
  @Output() printEvent = new EventEmitter<any>();
  selectedCurrency = 'NGN';

  selectedBankDetail: any;
  filteredDelete: Array<any> = [];
  modifiedScholarshipPayment: Array<any> = [];
  loading = true;

  constructor(
    private scholarshipInfService: ScholarshipInfoService,
    public matDialog: MatDialog,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    if (this.scholarshipData) {
      // console.log(this.scholarshipData.id);
      this.getPaymentEmit.emit(this.scholarshipData.id);
      this.getBankDetailEmit.emit(this.scholarshipData.id);
    }
  }

  openCreateBankDetailModal() {
    const dialogConfig = new MatDialogConfig();
    // The user can't close the dialog by clicking outside its body
    dialogConfig.disableClose = true;
    dialogConfig.id = 'modal-component';
    dialogConfig.height = '700px';
    dialogConfig.width = '90%';
    dialogConfig.data = {
      name: 'bankDetail',
      student: this.scholarshipData,
      bankDetails: this.bankDetails,
      banks: this.banks,
    };

    const modalDialog = this.matDialog.open(ModalComponent, dialogConfig);
    modalDialog.afterClosed().subscribe((result) => {
      if (result !== undefined) {
        if (result.type === 'save') {
          this.onBankDetailEmit.emit(result.formValue);
        }

        if (result.filteredDelete !== null) {
          this.deleteBankDetailEvent.emit(result.filteredDelete);
        }
      }
    });
  }

  openCreatePaymentModal() {
    if (this.bankDetails.length === 0) {
      this.openCreateBankDetailModal();
    } else {
      const dialogConfig = new MatDialogConfig();
      // The user can't close the dialog by clicking outside its body
      dialogConfig.disableClose = true;
      dialogConfig.id = 'modal-component';
      dialogConfig.height = '600px';
      dialogConfig.width = '50%';
      dialogConfig.data = {
        name: 'create',
        student: this.scholarshipData,
        bankDetails: this.bankDetails,
        banks: this.banks,
        currencies: this.currencies,
      };

      const modalDialog = this.matDialog.open(ModalComponent, dialogConfig);
      modalDialog.afterClosed().subscribe((result) => {
        // console.log(`Dialog result: ${result}`);
        if (result !== undefined) {
          if (result === 'bankDetail') {
            this.openCreateBankDetailModal();
          } else {
            this.paymentEmit.emit(result);
          }
        }
      });
    }

    // modalDialog.close('Pizza!');
  }

  openViewPaymentModal(value) {
    // console.log('view ', this.bankDetails)
    const dialogConfig = new MatDialogConfig();
    // The user can't close the dialog by clicking outside its body
    dialogConfig.disableClose = false;
    dialogConfig.id = 'modal-component';
    dialogConfig.height = '600px';
    dialogConfig.width = '50%';
    dialogConfig.data = {
      name: 'view',
      student: value,
      banks: this.banks,
      bankDetails: this.bankDetails,
      currencies: this.currencies,
    };

    const modalDialog = this.matDialog.open(ModalComponent, dialogConfig);
    modalDialog.afterClosed().subscribe((result) => {
      console.log(`Dialog result: ${result}`);
      if (result !== undefined) {
        // this.paymentEmit.emit(result);
      }
    });
  }

  openReportPaymentModal() {
    if (this.scholarshipPayments.length > 0) {
      const dialogConfig = new MatDialogConfig();
      // The user can't close the dialog by clicking outside its body
      dialogConfig.disableClose = false;
      dialogConfig.id = 'modal-component';
      dialogConfig.height = '700px';
      dialogConfig.width = '80%';
      dialogConfig.data = {
        name: 'report',
        student: this.scholarshipData,
        scholarshipPayment: this.scholarshipPayments,
        banks: this.banks,
        states: this.states,
        lgas: this.lgas,
        communities: this.communities,
        genders: this.genders,
        scholarshipTypes: this.scholarshipTypes,
        scholarshipCategories: this.scholarshipCategories,
        courseOfStudies: this.courseOfStudies,
        bankDetails: this.bankDetails,
        currencies: this.currencies,
      };

      const modalDialog = this.matDialog.open(ModalComponent, dialogConfig);
      modalDialog.afterClosed().subscribe((result) => {
        // console.log(`Dialog result: ${result}`);
        if (result !== undefined) {
          // this.paymentEmit.emit(result);
        }
      });
    }
  }

  getCourseOfStudy(value) {
    return this.scholarshipInfService.courseOfStudyName(
      this.courseOfStudies,
      value
    );
  }

  getCurrencyCode(id) {
    return this.currencies.find((item) => item.id === id).CurrencyCode;
  }

  getState(value) {
    return this.scholarshipInfService.stateName(this.states, value);
  }

  getScholarshipType(value) {
    return this.scholarshipInfService.scholarshipTypeName(
      this.scholarshipTypes,
      value
    );
  }

  getScholarshipCategory(value) {
    return this.scholarshipInfService.scholarshipCategoryName(
      this.scholarshipCategories,
      value
    );
  }

  getGender(value) {
    return this.scholarshipInfService.genderName(this.genders, value);
  }

  getCountry(value) {
    return this.scholarshipInfService.countryName(this.countries, value);
  }

  getLga(value) {
    return this.scholarshipInfService.lgaName(this.lgas, value);
  }

  getScholarshipSession(value) {
    return this.scholarshipInfService.scholarshipSessionName(
      this.scholarshipSessions,
      value
    );
  }

  getCommunity(value) {
    return this.scholarshipInfService.communityName(this.communities, value);
  }

  getDuration(value) {
    return this.scholarshipInfService.scholarshipAwardDurationName(
      this.scholarshipAwardDurations,
      value
    );
  }

  onEdit(value) {
    this.dispatchEdit.emit(value);
  }

  back() {
    this.taskEmit.emit('list');
  }
}
